import { render, staticRenderFns } from "./modal-ellipsis.vue?vue&type=template&id=87e9a3c6&"
import script from "./modal-ellipsis.vue?vue&type=script&lang=js&"
export * from "./modal-ellipsis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports